var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{staticStyle:{"margin-bottom":"60px"},attrs:{"custom":_vm.account}}),(_vm.$router.currentRoute.name == 'home')?_c('Hero',{attrs:{"custom":_vm.getSectionData('hero')}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }